<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Donation Information EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-3 fieldName">
            In EMR
          </div>
          <div class="col-3 fieldName">
            In OATS
          </div>
        </div>
        <div class="row" v-if="organ !== 'Liver'">
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="livingDonorToDonateTo"
              disabled
              label="Living Donor to Donate to"
              class="livingdonortodonate"
            />
          </div>
  
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="livingDonorToDonateToOATS"
              disabled
              label="Living Donor to Donate to"
              class="livingdonortodonateOATS"
            />
          </div>
        </div>
        <div
          v-if="organ === 'Liver'"
          class="row">
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="directedDonation"
              disabled
              label="Living Donor to Donate to"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              id="disabled-text"
              v-model="directedDonationOATS"
              disabled
              label="Living Donor to Donate to"
            />
          </div>
        </div>
        <div class="row" v-if="organ !== 'Liver' && livingDonorToDonateTo === 'Pre-selected Recipient'">
          <div class="col-3">
            <ADSTextInput
              id="disabled-text"
              v-model="preSelectedRecipient"
              disabled
              label="Preselected Recipient"
              class="livingdonortodonate"
            />
          </div>
  
          <div class="col-4">
            <ADSTextInput
              id="disabled-text"
              v-model="preSelectedRecipientOATS"
              disabled
              label="Preselected Recipient"
              class="livingdonortodonateOATS"
            />
          </div>
        </div>
        <div class="row" v-if="organ !== 'Liver' && livingDonorToDonateTo === 'To be allocated to a Recipient'">
          <div class="col-3">
            <ADSTextInput
              v-model="toBeAllocatedToARecipient"
              disabled
              label="To Be Allocated To A Recipient"
              class="toBeAllocatedToARecipient"
            />
          </div> 
  
          <div class="col-2">
            <ADSTextInput
              v-model="toBeAllocatedToARecipientOATS"
              disabled
              label="To Be Allocated To A Recipient"
              class="toBeAllocatedToARecipientOATS"
            />
          </div> 
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>
  
  <script>
  import _ from 'lodash';
  
  export default {
    name: "DonationInformationSectionEMROATS",
    props: {
      patient: {
        type: Object,
        default: null,
      },
      patientBundle: {
        type: Object,
        default: null,
      },
      organ: {
        type: String,
        default: null,
      },
      patientBundleOATS: {
        type: Object,
        default: null,
      }
    },
    data() {
      return {
        livingDonorToDonateTo: this.getLivingDonorToDonateTo( this.patientBundle ),
        livingDonorToDonateToOATS: this.getLivingDonorToDonateToOATS( this.patientBundleOATS ),
        preSelectedRecipient: this.getPreSelectedRecipient( this.patientBundle ),
        preSelectedRecipientOATS: this.getPreSelectedRecipientOATS( this.patientBundleOATS ),
        toBeAllocatedToARecipient: this.getToBeAllocatedToARecipient( this.patientBundle ),
        toBeAllocatedToARecipientOATS: this.getToBeAllocatedToARecipientOATS( this.patientBundleOATS ),
        directedDonation: this.getDirectedDonation( this.patientBundle ),
        directedDonationOATS: this.getDirectedDonationOATS( this.patientBundleOATS ),
      };
      },
     mounted() {
      
      },
    methods: {
      combineProps() {
        return `${this.patient}`;
      },
      getLivingDonorToDonateTo( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let livingDonorToDonateTo = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#361' ) ) ;
      if( livingDonorToDonateTo && livingDonorToDonateTo[ 0 ] ) {
        return _.get( livingDonorToDonateTo[0], 'resource.component[0].valueString' );  
      } 
      }
      },
      getLivingDonorToDonateToOATS( patientBundleOATS ) {
        let intended_recipients = _.get( patientBundleOATS,'living_donor_info.journeys[0].intended_recipients' );
        if( intended_recipients && intended_recipients[ 0 ] ) {
          return 'Pre-Selected recipient';
        }
        let kidney_paired_donation = _.get( patientBundleOATS,'indicators.kidney_paired_donation' );
        if( kidney_paired_donation === true ) return 'To be allocated to a Recipient';
        let list_exchange = _.get( patientBundleOATS,'journeys[0].list_exchange' );
        if( list_exchange === true ) return 'To be allocated to a Recipient';
      },
      getPreSelectedRecipient( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let preSelectedRecipient = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#362' ) ) ;
      if( preSelectedRecipient && preSelectedRecipient[ 0 ] ) {
        return _.get( preSelectedRecipient[0], 'resource.component[0].valueString' ); 
      } 
      }
      },
      getPreSelectedRecipientOATS( patientBundleOATS ) {
        let kidney_paired_donation = _.get( patientBundleOATS,'indicators.kidney_paired_donation' );
        if( kidney_paired_donation === true ) return 'Non-Directed Donation (KPD - End of Chain)';
        let list_exchange = _.get( patientBundleOATS,'journeys[0].list_exchange' );
        if( list_exchange === true ) return 'List Exchange';
        let intended_recipients = _.get( patientBundleOATS,'living_donor_info.journeys[0].intended_recipients' );
        if( intended_recipients && intended_recipients[ 0 ] ) {
          return 'Pre-Selected recipient';
        }
        return '';
      },
      getToBeAllocatedToARecipient( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let toBeAllocatedToARecipient = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#363' ) ) ;
      if( toBeAllocatedToARecipient && toBeAllocatedToARecipient[ 0 ] ) {
        return _.get( toBeAllocatedToARecipient[0], 'resource.component[0].valueString' ); 
      } 
      }
      },
      getToBeAllocatedToARecipientOATS( patientBundleOATS ) {
        let kidney_paired_donation = _.get( patientBundleOATS,'indicators.kidney_paired_donation' );
        if( kidney_paired_donation === true ) return 'Non-Directed Donation (KPD - End of Chain)';
        let list_exchange = _.get( patientBundleOATS,'journeys[0].list_exchange' );
        if( list_exchange === true ) return 'List Exchange';
        let intended_recipients = _.get( patientBundleOATS,'living_donor_info.journeys[0].intended_recipients' );
        if( intended_recipients && intended_recipients[ 0 ] ) {
          return 'Pre-Selected recipient';
        }
        return '';
      },
      getDirectedDonation( patientBundle ) {
        let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
        if( observation && observation[ 0 ] ) {
          let directedDonation = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#4069' ) ) ;
        if( directedDonation && directedDonation[ 0 ] ) {
          return _.get( directedDonation[0], 'resource.component[0].valueString' ); 
        } 
      }
        },
        getDirectedDonationOATS( patientBundleOATS ) {
          let directedDonation = _.get( patientBundleOATS,'living_donor_info.journeys[0].directed_donation' );
          if( directedDonation === true ) return 'Directed Donation';
          return '';
      },
      },
     
  };
  </script>
  
  <style scoped>
  
  /* .card {
    height: 340px;
  } */
  
  .sectionHeading {
    background-color: rgb(59, 53, 53);
    color: white;
    padding-left: 5px;
  }
  .page-content .summary-card .card-header .summary-name {
    padding-left: 35px;
    padding-top: 4px;
    font-weight: 300;
  }
  
  .sections {
    font-size: 15px;
    height: 400px;
    width: 1400px;
    /* overflow: scroll; */
    padding-left: 10px;
    /* padding-top: 5px; */
  }
  
  .inputDisplay {
  border-style: solid;
  background-color: #F2F2F2;
  }
  
  .fieldName {
    font-weight: 700;
    font-size: 0.875rem;
    /* padding-top: 5.5px; */
    /* padding-bottom: 2.5px; */
    /* padding-right: 15px; */
    padding-inline-start: 2%;
  }
  
  :deep(.afflo-ds-form-control) {
    width: max-content;
  }
  
  :deep(label) {
    width: max-content;
  }
  
  :deep(.ExceptionalDistributionReasonOther .afflo-ds-form-control) {
    width: 400px;
  }
  
  :deep(.livingdonortodonate .afflo-ds-form-control) {
    width: 300px;
  }
  
  :deep(.livingdonortodonateOATS .afflo-ds-form-control) {
    width: 370px;
  }
  
  :deep(.toBeAllocatedToARecipientOATS .afflo-ds-form-control) {
    width: 370px;
  }
  
  </style>
  